import { api } from "../../../../services/api";

export async function openCashRegister({ companyId, token, amount }) {
  await api.post("/openCashRegister", {
    company: companyId,
    token,
    amount
  });
}
